import React from 'react'

export const Loader = () => {
    return (
        <div className="lds-ring" style={{display: "inline-block"}}>
            <div/>
            <div/>
            <div/>
            <div/>
        </div>
    )
}
